import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { getFactor, postFactor } from "../../../redux/actions";
import styles from "./postFactor.module.css";

const Factores = () => {
  const [nombre, setNombre] = useState("");
  const [factor, setFactor] = useState("");
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const factores = useSelector((state) => state.facarga);

  useEffect(() => {
    dispatch(getFactor());
  }, [dispatch]);

  const handleCrearFactor = async () => {
    if (nombre.trim() === "" || factor.trim() === "") {
      setError("Todos los campos son obligatorios.");
      return;
    }

    const valorFactor = parseFloat(factor);

    if (isNaN(valorFactor) || valorFactor <= 0) {
      setError("El factor debe ser un número mayor a 0.");
      return;
    }

    const nuevoFactor = {
      descripcion: nombre,
      factor: valorFactor,
    };

    try {
      await dispatch(postFactor(nuevoFactor)); // Ya no se envía como arreglo
      setNombre("");
      setFactor("");
      setError("");
      dispatch(getFactor());

      Swal.fire({
        icon: "success",
        title: "Factor creado",
        text: "El factor fue creado con éxito",
        confirmButtonColor: "#3559d1"
      });

    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.error || "Ocurrió un error al crear el factor"
      });
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.titulo}>Factor de carga</h2>

      <input
        type="text"
        placeholder="Escriba el nombre del factor"
        value={nombre}
        onChange={(e) => setNombre(e.target.value)}
        className={styles.input}
      />

      <input
        type="number"
        placeholder="Factor"
        value={factor}
        onChange={(e) => setFactor(e.target.value)}
        className={styles.input}
        min="0.01"
        step="0.01"
      />

      {error && <p className={styles.error}>{error}</p>}

      <button onClick={handleCrearFactor} className={styles.boton}>
        Crear Factor
      </button>

      <label className={styles.label}>Factores registrados:</label>
      <select className={styles.select}>
        {factores?.length > 0 ? (
          factores.map((fac) => (
            <option key={fac.id} value={fac.descripcion}>
              {`${fac.descripcion} - ${fac.factor} t`}
            </option>
          ))
        ) : (
          <option disabled>No hay factores registrados</option>
        )}
      </select>
    </div>
  );
};

export default Factores;
